export const addCharacter = (characters, character) => {
  const franchiseId = character.franchise_id;
  const franchise = characters[franchiseId] ?? {
    name: character.franchise_name,
    characters: {},
  };

  return {
    ...characters,
    [franchiseId]: {
      ...franchise,
      characters: {
        ...franchise.characters,
        [String(character.franchise_character_id)]: {
          name: character.name,
          franchiseCharacterId: character.franchise_character_id,
          titleCharacterId: null,
          influencerId: null,
          influencerName: null,
          influencerAvatarUrl: null,
        },
      },
    },
  };
};

const withoutKey = (object, key) =>
  Object.fromEntries(Object.entries(object).filter(([k]) => k !== String(key)));

export const removeCharacter = (characters, { franchiseId, characterId }) => {
  const remaining = withoutKey(
    characters[franchiseId]?.characters ?? {},
    characterId,
  );

  return Object.keys(remaining).length === 0
    ? withoutKey(characters, franchiseId)
    : {
        ...characters,
        [franchiseId]: { ...characters[franchiseId], characters: remaining },
      };
};

export const characterList = (characters) =>
  Object.entries(characters).flatMap(([franchiseId, franchise]) =>
    Object.entries(franchise.characters).map(([characterId, character]) => ({
      franchiseId: Number(franchiseId),
      franchiseName: franchise.name,
      characterId,
      characterName: character.name,
      franchiseCharacterId: character.franchiseCharacterId,
    })),
  );
